import React, { createContext, useContext, useState } from 'react';

const UserStateContext = createContext();
const UserDispatchContext = createContext();

const UserProvider = ({ children }) => {
	const [user, setUser] = useState({});
	return (
		<UserStateContext.Provider value={user}>
			<UserDispatchContext.Provider value={setUser}>
				{children}
			</UserDispatchContext.Provider>
		</UserStateContext.Provider>
	);
};

const useUserState = () => {
	const context = useContext(UserStateContext);
	if (context === undefined) {
		throw new Error('useUserState must be used within a UserProvider');
	}
	return context;
};

const useUserDispatch = () => {
	const context = useContext(UserDispatchContext);
	if (context === undefined) {
		throw new Error('useUserDispatch must be used within a UserProvider');
	}
	return context;
};

export { UserProvider, useUserState, useUserDispatch };
